module.exports = __webpack_public_path__ + "img/car_icon_map.b8134b98.png";